import { notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'
import { saveAs } from 'file-saver'

export const getUploadPrefixFromSelection = (directoriesData, selectedKeys) => {
  if (!selectedKeys.length) return ''

  const path = findPathByKey(directoriesData, selectedKeys[0])
  if (!path || !path.length) return ''

  const selectedNode = path[path.length - 1]

  if (selectedNode.type === 'folder') {
    return selectedNode.upload_prefix || ''
  }

  if (selectedNode.type === 'file' && path.length > 1) {
    return path[path.length - 2].upload_prefix || ''
  }

  return ''
}

export const onConfirmUpload = ({
  setIsLoading,
  breadcrumbPath,
  uploadFileS3,
  fileList,
  uploadUrlAws,
  onRefetch,
  onClose,
  setAuditS3,
  onRefetcAuditList,
  enableOldS3,
  directoriesData,
  selectedKeys,
}) => {
  // const folders = breadcrumbPath.length > 0 ? breadcrumbPath.map((el) => el.title).join('/') : ''

  const uploadPrefix = getUploadPrefixFromSelection(directoriesData, selectedKeys)

  setIsLoading(true)
  uploadFileS3(
    { 'content-type': fileList[0].type },
    { file_name: fileList[0].name, file_prefix: uploadPrefix },
  )
    .then((response) => {
      uploadUrlAws(response, fileList[0], enableOldS3).then((response2) => {
        if (response2.status === 204) {
          Promise.all([
            setAuditS3({ file_name: fileList[0].name, operation: 'upload' }),
            onRefetch(),
          ]).then(() => {
            onRefetcAuditList()
            notification.success({
              description: i18n.t('FEEDBACK_UPLOAD_FILE_SUCCESS', {
                configModule: fileList[0].name,
              }),
              duration: 8,
            })
            onClose()
          })
        } else {
          notification.error({
            message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
            description: generateMessageError(response2, 'FEEDBACK_UPLOAD_FILE_ERROR', {
              fileName: fileList[0].name,
            }),
            duration: 0,
          })
          onClose()
        }
      })
    })
    .catch((error) => {
      notification.error({
        message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
        description: generateMessageError(error, 'FEEDBACK_UPLOAD_FILE_ERROR', {
          fileName: fileList[0].name,
        }),
        duration: 0,
      })
      onClose()
    })
}

export const addFolder = (data, parentKey, folderName2) => {
  const generateKey = (parentKey, childrenCount) => {
    return parentKey ? `${parentKey}.${childrenCount}` : `${childrenCount}`
  }

  const traverseAndAdd = (nodes) => {
    return nodes.map((node) => {
      if (node.key === parentKey) {
        const children = node.children || []
        const newKey = generateKey(parentKey, children.length)

        const newFolder = {
          title: folderName2,
          key: newKey,
          type: 'folder',
          isLeaf: false,
          children: [],
        }

        return {
          ...node,
          children: [...children, newFolder],
        }
      }

      if (node.children) {
        return {
          ...node,
          children: traverseAndAdd(node.children),
        }
      }

      return node
    })
  }

  if (!parentKey) {
    const newKey = generateKey(null, data.length)
    const newFolder = {
      title: folderName2,
      key: newKey,
      type: 'folder',
      isLeaf: false,
      children: [],
    }
    return [...data, newFolder]
  }

  return traverseAndAdd(data)
}

// const findMinimalPathToChild = (data, key, currentPath = []) => {
//   for (const node of data) {
//     const newPath = [...currentPath, node]

//     if (node.children && node.children.length > 0) {
//       const childFound = node.children.find((child) => child.key === key)

//       if (childFound) {
//         return [...newPath, childFound]
//       }

//       const found = findMinimalPathToChild(node.children, key, newPath)
//       if (found) return found
//     }
//   }
//   return null
// }

// const getMinimalChildPathInfo = (data, key) => {
//   const minimalPath = findMinimalPathToChild(data, key)

//   if (!minimalPath) {
//     return {
//       path: [],
//       names: [],
//       childNode: null,
//       exists: false,
//     }
//   }

//   const childNode = minimalPath[minimalPath.length - 1]

//   return {
//     path: minimalPath,
//     names: minimalPath.map((node) => node.title),
//     childNode: childNode,
//     exists: true,
//   }
// }

function buildUploadPrefixMap(nodes, inheritedPrefix = null, map = {}) {
  for (const node of nodes) {
    let currentPrefix = inheritedPrefix

    if (node.type === 'folder' && node.upload_prefix) {
      currentPrefix = node.upload_prefix
    }

    map[node.key] = currentPrefix

    if (Array.isArray(node.children)) {
      buildUploadPrefixMap(node.children, currentPrefix, map)
    }
  }

  return map
}

export const handleDownload = async ({
  key,
  record,
  directoriesData,
  downloadFileS3,
  loggedUser,
  setAuditS3,
  onRefetcAuditList,
}) => {
  try {
    // const childInfo = getMinimalChildPathInfo(directoriesData, key)

    const result = buildUploadPrefixMap(directoriesData)

    // const minimalPath = childInfo.names.length > 0 ? childInfo.names.join('/') : record.nombre

    const response = await downloadFileS3({
      file_key: `${loggedUser.society_code}/${result[key]}/${record.nombre}`,
    })
    const response2 = await fetch(response.payload.data.url, {
      method: 'GET',
    })

    const blob = await response2.blob()

    saveAs(blob, record.nombre)
    setAuditS3({ file_name: record.nombre, operation: 'download' }).then(() => {
      onRefetcAuditList()
    })
  } catch (error) {
    notification.error({
      message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
      description: generateMessageError(error),
      duration: 0,
    })
  }
}

const mapNodeToRow = (node) => ({
  key: node.key,
  nombre: node.title,
  tipo: node.type,
  tamaño: node.size ? `${node.size} bytes` : '',
  fecha: node.timestamp ? new Date(node.timestamp).toLocaleString() : '',
  esHoja: node.isLeaf ? 'Sí' : 'No',
})

export const generateTableData = (selectedKeys, directoriesData) => {
  if (selectedKeys.length === 0) {
    return directoriesData.map(mapNodeToRow)
  }

  const selectedKey = selectedKeys[0]
  const path = findPathByKey(directoriesData, selectedKey)
  if (!path) return []

  const selectedNode = path[path.length - 1]

  if (selectedNode.type === 'folder') {
    return (selectedNode.children || []).map(mapNodeToRow)
  }

  if (selectedNode.type === 'file' && path.length > 1) {
    const parentNode = path[path.length - 2]
    return (parentNode.children || []).map(mapNodeToRow)
  }

  if (selectedNode.type === 'file' && path.length === 1) {
    return directoriesData.map(mapNodeToRow)
  }

  return []
}

export const findNodeByKey = (data, key) => {
  for (let node of data) {
    if (node.key === key) return node
    if (node.children) {
      const found = findNodeByKey(node.children, key)
      if (found) return found
    }
  }
  return null
}

export const findPathByKey = (data, key, path = []) => {
  for (let node of data) {
    if (node.key === key) {
      return [...path, node]
    }
    if (node.children) {
      const found = findPathByKey(node.children, key, [...path, node])
      if (found) return found
    }
  }
  return null
}

export const transformData = (data) => {
  return data.map((item) => {
    const transformedItem = {
      title: item.name,
      key: item.position,
      type: item.type,
      isLeaf: item.isLeaf,
      upload_prefix: item.upload_prefix,
      children: item.children ? transformData(item.children) : null,
      ...(item.size && { size: item.size }),
      ...(item.timestamp && { timestamp: item.timestamp }),
    }

    return transformedItem
  })
}
